var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('el-main',{staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"content",staticStyle:{"background-color":"#f9f9f9"}},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }